@if (isInitialized && formGroup) {
  <oe-modal [title]="component.alias" [component]="component" [formGroup]="formGroup"
    helpKey="CONTROLLER_ESS_TIME_OF_USE_TARIFF">

    <oe-modal-line [name]="'GENERAL.STATUS' | translate" [converter]="CONVERT_TIME_OF_USE_TARIFF_STATE"
      [channelAddress]="component.id + '/StateMachine'"></oe-modal-line>

    <oe-modal-line [name]="'EDGE.INDEX.WIDGETS.TIME_OF_USE_TARIFF.CONSUMPTION_PRICE' | translate"
      [value]="consumptionPriceWithCurrency"></oe-modal-line>

    <oe-modal-line [name]="'EDGE.INDEX.WIDGETS.TIME_OF_USE_TARIFF.PRODUCTION_PRICE' | translate"
      [value]="productionPriceWithCurrency"></oe-modal-line>

    <oe-modal-horizontal-line></oe-modal-horizontal-line>

    <oe-modal-line [name]="'GENERAL.MODE' | translate"></oe-modal-line>
    <oe-modal-buttons [formGroup]="formGroup" controlName="mode" [component]="component" [buttons]="[
        { name: ('GENERAL.AUTOMATIC' | translate), value: 'AUTOMATIC', icon: {color:'primary', name: 'sunny'}},
        { name: ('GENERAL.OFF' | translate), value: 'OFF', icon: {color:'danger', name: 'power'}}]">
    </oe-modal-buttons>

    @if (component.factoryId === 'Controller.Ess.Time-Of-Use-Tariff') {
      @if (formGroup.value.mode === 'AUTOMATIC') {
        <oe-modal-horizontal-line></oe-modal-horizontal-line>
        <oe-modal-info-line
          [info]="'EDGE.INDEX.WIDGETS.TIME_OF_USE_TARIFF.CHART_TITLE' | translate"></oe-modal-info-line>
        <statePriceChart class="ion-padding" [refresh]="refreshChart" [component]="component" [edge]="edge">
        </statePriceChart>
        <oe-modal-info-line [info]="'EDGE.INDEX.WIDGETS.TIME_OF_USE_TARIFF.CHART_WARNING_NOTE' | translate"
          style="font-size: small;"></oe-modal-info-line>

        @if (edge.roleIsAtLeast('admin')) {
          <oe-modal-horizontal-line></oe-modal-horizontal-line>
          <oe-modal-info-line [info]="'EDGE.INDEX.WIDGETS.TIME_OF_USE_TARIFF.POWER_SOC_CHART_TITLE' | translate">
          </oe-modal-info-line>
          <powerSocChart class="ion-padding" [refresh]="refreshChart" [component]="component" [edge]="edge">
          </powerSocChart>
        }
      }

      @if (formGroup.value.mode === 'OFF') {
        <oe-modal-horizontal-line></oe-modal-horizontal-line>
        <ion-card-content></ion-card-content>
      }

      <oe-modal-horizontal-line></oe-modal-horizontal-line>

      <oe-modal-line [name]="'EDGE.INDEX.WIDGETS.TIME_OF_USE_TARIFF.ALLOW_CHARGE_FROM_GRID' | translate"
        [formGroup]="formGroup" controlName="allowChargeFromGrid" [control]="{ type: 'TOGGLE' }"
        leftColumnWidth="100">
      </oe-modal-line>

      <ng-container style="font-size: smaller">
        @if (formGroup.value.allowChargeFromGrid) {
          <span
            [innerHtml]="'EDGE.INDEX.WIDGETS.TIME_OF_USE_TARIFF.CONTROL_MODE_DESCRIPTION.ALLOW_CHARGE_FROM_GRID' | translate">
          </span>
        }
      </ng-container>

      <oe-modal-line [name]="'EDGE.INDEX.WIDGETS.TIME_OF_USE_TARIFF.ENABLE_PEAK_SHAVING_RESERVE' | translate"
        [formGroup]="formGroup" controlName="enablePeakShavingReserve" [control]="{ type: 'TOGGLE' }"
        leftColumnWidth="100">
      </oe-modal-line>

      <ng-container style="font-size: smaller">
        @if (formGroup.value.enablePeakShavingReserve) {
          <span
            [innerHtml]="'EDGE.INDEX.WIDGETS.TIME_OF_USE_TARIFF.CONTROL_MODE_DESCRIPTION.PEAK_SHAVING_RESERVE' | translate">
          </span>
        }
      </ng-container>

      @if (formGroup.value.enablePeakShavingReserve) {
        <oe-modal-line [name]="'EDGE.INDEX.WIDGETS.TIME_OF_USE_TARIFF.PEAK_SHAVING_POWER' | translate"
          [formGroup]="formGroup" controlName="peakShavingPower"
          [control]="{ type: 'INPUT', properties: { unit: 'W' } }"
          [leftColumnWidth]="65">
        </oe-modal-line>
      }

      <oe-modal-line [name]="'EDGE.INDEX.WIDGETS.TIME_OF_USE_TARIFF.ENABLE_DISCHARGE_GRID' | translate"
        [formGroup]="formGroup" controlName="enableDischargeGrid" [control]="{ type: 'TOGGLE' }"
        leftColumnWidth="100">
      </oe-modal-line>

      <ng-container style="font-size: smaller">
        @if (formGroup.value.enableDischargeGrid) {
          <span
            [innerHtml]="'EDGE.INDEX.WIDGETS.TIME_OF_USE_TARIFF.CONTROL_MODE_DESCRIPTION.DISCHARGE_GRID' | translate">
          </span>
        }
      </ng-container>

      @if (formGroup.value.enableDischargeGrid) {
        <oe-modal-line [name]="'EDGE.INDEX.WIDGETS.TIME_OF_USE_TARIFF.DISCHARGE_POWER_IN_DISCHARGE_GRID' | translate"
          [formGroup]="formGroup" controlName="dischargeToGridPower"
          [control]="{ type: 'INPUT', properties: { unit: 'W' } }"
          [leftColumnWidth]="65">
        </oe-modal-line>

        <oe-modal-line [name]="'EDGE.INDEX.WIDGETS.TIME_OF_USE_TARIFF.MIN_SOC_FOR_DISCHARGE_GRID' | translate"
          [formGroup]="formGroup" controlName="minSocForDischargeGrid"
          [control]="{ type: 'INPUT', properties: { unit: '%' } }"
          [leftColumnWidth]="65">
        </oe-modal-line>
      }
    }
  </oe-modal>
}
